import React from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { LogoType } from '../../../static/types/commonTypes/logoType';

interface LogoDeleteModalProps {
  show: boolean;
  selectedLogos: number[];
  logos: LogoType[];
  deletionReason: string;
  isDeletingLogos: boolean;
  primaryColor: string;
  onHide: () => void;
  onDeletionReasonChange: (value: string) => void;
  onConfirmDelete: () => void;
}

const LogoDeleteModal: React.FC<LogoDeleteModalProps> = ({
  show,
  selectedLogos,
  logos,
  deletionReason,
  isDeletingLogos,
  primaryColor,
  onHide,
  onDeletionReasonChange,
  onConfirmDelete,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
    >
      <Modal.Header 
        closeButton 
        style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dc3545' }}
      >
        <Modal.Title style={{ color: '#dc3545', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaTrash size={20} />
          Confirmation de suppression
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning">
          <strong>Attention !</strong> Vous êtes sur le point de supprimer{' '}
          <strong>{selectedLogos.length}</strong> logo(s).
          Cette action est irréversible.
        </Alert>

        <Form.Group className="mb-3">
          <Form.Label style={{ fontWeight: 'bold', color: '#333' }}>
            Motif de suppression <span style={{ color: '#dc3545' }}>*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={deletionReason}
            onChange={(e) => onDeletionReasonChange(e.target.value)}
            placeholder="Expliquez la raison de la suppression (visible par l'utilisateur)..."
            required
          />
          <Form.Text className="text-muted">
            Ce motif sera envoyé par email à l'utilisateur
          </Form.Text>
        </Form.Group>

        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '15px',
          borderRadius: '8px',
          border: '1px solid #dee2e6'
        }}>
          <h6 style={{ color: primaryColor, marginBottom: '10px' }}>Logos concernés :</h6>
          <ul style={{ marginBottom: 0 }}>
            {logos
              .filter(logo => selectedLogos.includes(logo.id))
              .map(logo => (
                <li key={logo.id}>
                  Logo #{logo.id} - {logo.libelle.split('/').pop()}
                </li>
              ))}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: '#f8f9fa' }}>
        <Button
          variant="outline-secondary"
          onClick={onHide}
          disabled={isDeletingLogos}
        >
          Annuler
        </Button>
        <Button
          style={{ backgroundColor: '#dc3545', border: 'none' }}
          onClick={onConfirmDelete}
          disabled={isDeletingLogos || !deletionReason.trim()}
        >
          {isDeletingLogos ? (
            <Spinner animation="border" size="sm" />
          ) : (
            'Confirmer la suppression'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoDeleteModal;